import { Grid, Slide, Typography } from "@mui/material";
import { FORM_IMAGE_KEYS } from "../utils/constants";
import { useTranslation } from "react-i18next";
import { getFromValueSelector } from "../utils/selectorHelpers";
import { imagesSelector } from "../utils/selectorHelpers";
import { useSelector } from "react-redux";

export default function AppPreviewFormData({
  formData,
  bankForm,
  mode = null,
}) {
  const { t } = useTranslation();
  const formValues = useSelector(getFromValueSelector);
  const images = useSelector(imagesSelector);

  const label = (key) => {
    const values = bankForm.find(
      (field) =>
        field.name ===
        key.replaceAll("bankDetail", "").replaceAll("personalDetail", "")
    );
    if (values.link) {
      return '';
    }
    return values.label || "";
  };
  const renderValueComponent = (value, key) => {
    const filteredKey = key
      .replaceAll("bankDetail", "")
      .replaceAll("personalDetail", "");
    const fields = formValues?.fields;
    if (fields?.[filteredKey]) {
      // eslint-disable-next-line eqeqeq
      let newVal = fields?.[filteredKey]?.find(v => v.value == value);
      value = newVal?.key || value;
    }
    const values = bankForm.find(
      (field) =>
        field.name === filteredKey
    );
    if (values.link) {
      return '';
    }
    const arr = Object.values(bankForm).flat();
    const find = arr.find(v => v.name === filteredKey);
    if (find && find.type === 'select' && find?.acceptedValues?.length && typeof find?.acceptedValues?.[0]?.key === 'string') {
      const findValue = find?.acceptedValues?.find(v => {
        const vValue = v.value != null ? String(v.value) : '';
        const vKey = v.key != null ? String(v.key) : '';
        const compareValue = value != null ? String(value) : '';
        return vValue.toLowerCase() === compareValue.toLowerCase()
        || vKey.toLowerCase() === compareValue.toLowerCase()
      });
      value = findValue?.key;
    }
    if (FORM_IMAGE_KEYS.indexOf(filteredKey) >= 0 && value) {
      const preview = images?.[key]
      return (
        <img
          src={preview}
          alt="Preview"
          width="auto"
          height="auto"
          style={{ maxWidth: 80, maxHeight: 60, borderRadius: 2 }}
        />
      );
    } else {
      return (
        <Typography
          // textAlign="right"
          fontSize={14}
          sx={{
            overflowWrap: "break-word",
            maxWidth: "100%", // or specify a fixed width like '200px'
          }}
        >
          {value || "N/A"}
        </Typography>
      );
    }
  };
  return (
    <Grid container>
      {mode === "ADD" && (
        <Grid item xs={12}>
          <Slide in={true} direction="left" mountOnEnter unmountOnExit>
            <Typography variant="h6" textAlign={"left"}>
              {t("updateBank.confirm")}
            </Typography>
          </Slide>
        </Grid>
      )}

      {mode === "ADD" && (
        <Grid item xs={12}>
          <Slide in={true} direction="left" mountOnEnter unmountOnExit>
            <Typography
              variant="subtitle2"
              textAlign={"left"}
              marginTop={1}
              marginBottom={1}
            >
              {t("updateBank.currentInfo")}:
            </Typography>
          </Slide>
        </Grid>
      )}
      {Object.keys(formData).map((key, index) => (
        <>
          <Grid item xs={12} key={key + index} marginTop={1}>
            <Typography
              fontSize={14}
              fontWeight={700}

            >    {label(key)}</Typography>

          </Grid>
          <Grid item xs={12} key={index} marginTop={-0.1}>
            {renderValueComponent(formData[key], key)}
          </Grid>
        </>
      ))}
    </Grid>
  );
}
